import React from 'react';
import styles from './RoadmapItem.module.css';

interface RoadmapItemProps {
    status: 'current' | 'planned' | 'future';
    title: string;
    children: React.ReactNode;
}

export const RoadmapItem: React.FC<RoadmapItemProps> = ({ status, title, children }) => {
    return (
        <div className={styles.roadmapItem}>
            <div className={`${styles.roadmapStatus} ${styles[`roadmapStatus${status.charAt(0).toUpperCase() + status.slice(1)}`]}`}>
                {status === 'current' && '🚀'}
                {status === 'planned' && '🔧'}
                {status === 'future' && '📅'}
            </div>
            <div className={styles.roadmapContent}>
                <h4>{title}</h4>
                {children}
            </div>
        </div>
    );
};